export default __webpack_public_path__ + "static/media/warning.0f2031d3.jpg";